<template>
  <el-card
    v-loading="loading"
    shadow="never">
    <el-form
      :model="form"
      :rules="rules"
      class="el-form-width"
      ref="form"
      label-width="100px"
      @submit.native.prevent>
      <el-upload
        class="avatar-uploader"
        :action="imgApi"
        accept="image"
        :show-file-list="false"
        :on-success="uploadSuccess"
        :on-error="uploadError"
        :before-upload="beforeUpload">
        <img v-if="imageUrl" :src="imageUrl" class="avatar">
        <span v-if="!imageUrl" class="avatar-uploader-icon">点击上传封面图</span>
      </el-upload>
      <el-form-item
        class="customizeCss"
        prop="title"
        label="标题"
      >
        <el-input type="text" v-model="form.title" placeholder="请填写标题"></el-input>
      </el-form-item>
      <el-form-item
        prop="subTitle"
        label="副标题"
      >
        <el-input type="text" v-model="form.subTitle" placeholder="请填写副标题"></el-input>
      </el-form-item>
      <el-form-item
        prop="seqNum"
        label="排序号"
      >
        <el-input type="number" v-model="form.seqNum" placeholder="请填写排序号"></el-input>
      </el-form-item>
      <el-form-item
          prop="source"
          label="视频来源"
        >
          <el-input type="text" v-model="form.source" placeholder="请填写视频来源"></el-input>
        </el-form-item>
        <el-form-item
          prop="remark"
          label="备注"
          class="ipt-textarea"
        >
          <el-input type="textarea" v-model="form.remark" placeholder="请填写备注" resize="none"></el-input>
        </el-form-item>
      <el-form-item
        class="form-upload-video"
        label="上传视频">
        <video-player  class="video-player-box"
                       ref="videoPlayer"
                       :options="playerOptions"
                       :playsinline="true"
                       customEventName="customstatechangedeventname">
        </video-player>
        <div>
          <input  type="file" accept="video/avi,video/mp4,video/flv,video/3gp,video/swf,video/x-ms-wmv,video/wmv"  @change="onFileChange" />
          <el-button type="success" @click="complete">确认上传</el-button>
        </div>
      </el-form-item>
      <div class="tc">
        <el-button
          style="width: 140px"
          @click="goBack">返回
        </el-button>
        <el-button
          style="width: 140px"
          type="primary"
          @click="onSubmit">保存
        </el-button>
      </div>
    </el-form>
  </el-card>
</template>

<script>
import {news} from '../../api'
import {validImage, validVideo, quillUploadSuccess} from '@/utils'
import {getSession} from '../../utils/session'
import {ORG_CODE, USER_ID} from '../../constants'
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'

import $ from 'jquery'

export default {
  name: 'NewsVideoForm',
  props: {
    newsId: String
  },
  components: {
    videoPlayer
  },
  mounted () {
    if (this.newsId) {
      this.getNewsDetail()
    }
  },
  data () {
    return {
      imgApi: process.env.VUE_APP_API + '/upload/image/single/',
      videoApi: process.env.VUE_APP_API + '/upload/image/uploadVideo',
      loading: false,
      submitting: false,
      dialogFormVisible: false,
      imageUrl: '',
      file: '',
      videoProgress: 0,
      videoUrl: '',
      form: {
        newsId: '',
        orgCode: getSession(ORG_CODE),
        type: '2',
        title: '',
        subTitle: '',
        source: '',
        filePath: '',
        coverImgs: '',
        seqNum: '',
        createUser: getSession(USER_ID),
        remark: ''
      },
      rules: {
        classCode: [
          {required: true, message: '请选择资讯分类', trigger: 'change'}
        ],
        title: [
          {required: true, message: '请填写标题', trigger: 'blur'}
        ],
        subTitle: [
          {required: true, message: '请填写副标题', trigger: 'blur'}
        ],
        source: [
          {required: true, message: '请填写视频来源', trigger: 'blur'}
        ]
      },
      playerOptions: {
        // videojs options
        muted: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: 'video/mp4',
          src: ''
        }],
        poster: ''
      }
    }
  },
  methods: {
    async getNewsDetail () {
      this.loading = true
      let {data} = await news.getNewsDetail(this.newsId)
      console.log(data)
      this.loading = false
      if (data.coverImgs) {
        this.imageUrl = process.env.VUE_APP_IMG + data.coverImgs
      }
      if (data.filePath) {
        this.videoUrl = process.env.VUE_APP_IMG + data.filePath
        this.playerOptions = {
          // videojs options
          muted: true,
          language: 'en',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          sources: [{
            type: 'video/mp4',
            src: this.videoUrl
          }],
          poster: ''
        }
      }
      delete data.createTime
      this.form = data
    },
    async goBack () {
      this.$closeCurrentView()
      this.$router.back()
    },
    onFileChange (value) {
      let files = value.target.files
      if (!files.length) return
      this.file = files[0]
    },
    complete () {
      let vaildFlag = validVideo(this.file, 50, [])
      if (vaildFlag) {
        this.loading = vaildFlag
      } else {
        return
      }
      const formData = new FormData()
      formData.append('file', this.file)
      let _this = this
      $.ajax({
        url: _this.videoApi,
        type: 'POST',
        timeout: 6000000,
        cache: false,
        data: formData,
        processData: false,
        contentType: false,
        dataType: 'json',
        success: function (data) {
          _this.loading = false
          _this.$refs.videoPlayer.src = process.env.VUE_APP_IMG + data.data
          _this.videoUrl = process.env.VUE_APP_IMG + data.data
          _this.form.filePath = data.data
          _this.playerOptions = {
            // videojs options
            muted: true,
            language: 'en',
            playbackRates: [0.7, 1.0, 1.5, 2.0],
            sources: [{
              type: 'video/mp4',
              src: _this.videoUrl
            }],
            poster: ''
          }
        },
        error: function (error) {
          console.log(error)
          _this.loading = false
          _this.$message({type: 'error', message: '上传视频失败，请稍后重试'})
        }
      })
    },
    async onSubmit () {
      await this.$refs.form.validate()
      if (!this.form.coverImgs) {
        this.$message({
          type: 'error',
          message: '请上传封面图'
        })
        return
      }
      if (!this.form.filePath) {
        this.$message({
          type: 'error',
          message: '请上传视频'
        })
        return
      }
      this.submitting = true
      if (this.form.newsId) {
        let {code, msg} = await news.updateNews({
          ...this.form
        })
        this.submitting = false
        if (code === 0) {
          this.$message({
            type: 'success',
            message: msg || '资讯修改成功'
          })
          this.$bus.$emit('updateNewsVideoList')
          this.$closeCurrentView()
          this.$router.back()
        } else {
          this.$message({
            type: 'error',
            message: msg || '资讯修改失败'
          })
        }
      } else {
        let {code, msg} = await news.addNews(this.form)
        this.submitting = false
        if (code === 0) {
          this.$message({
            type: 'success',
            message: msg || '资讯添加成功'
          })
          this.$bus.$emit('updateNewsVideoList')
          this.$closeCurrentView()
          this.$router.back()
        } else {
          this.$message({
            type: 'error',
            message: msg || '资讯添加失败'
          })
        }
      }
    },
    selNesClass (val) {
      let item = this.newsClassOption.find(x => x.classCode === val)
      this.form.className = item.name
    },
    uploadSuccess (res, file) {
      this.loading = false
      this.imageUrl = process.env.VUE_APP_IMG + res.data
      this.form.coverImgs = res.data
    },
    uploadError () {
      this.loading = false
      this.$message({type: 'error', message: '上传图片失败，请稍后重试'})
    },
    beforeUpload (file) {
      let vaildFlag = validImage(file, 500)
      this.loading = vaildFlag
      return vaildFlag
    }
  }
}
</script>
<style lang="scss" scoped>
  .el-form-width {
    width: 800px;
  }
  .el-card {
    border: none;
    /deep/ .el-card__body {
      padding-top: 30px;
      .el-form {
        &.el-form--inline {
          width: 745px;
        }
        .el-form-item__content,
        .el-date-editor.el-input,
        .el-input--suffix {
          width: 300px;
        }
        .ipt-textarea {
          display: block;
          .el-form-item__content {
            width: 300px;
          }
        }
      }
      .avatar-uploader {
        margin-top: 40px;
        .el-upload,
        .el-upload--text {
          margin-left: 550px;
        }
      }
      .customizeCss {
        margin-top: -215px;
      }
      .form-upload-video .el-form-item__content,
      .form-upload-video .avatar-upload-video{
        width: 100%;
      }
      .avatar-upload-video .el-upload {
        width: 100%;
        height: 300px;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      .avatar-upload-video .el-upload:hover {
        border-color: #409EFF;
      }
      .avatar-upload-video .avatar-uploader-icon {
        font-size: 16px;
        color: #8c939d;
        width: 100%;
        height: 300px;
        line-height: 300px;
        text-align: center;
      }
      .avatar-upload-video .avatar {
        width: 178px;
        height: 178px;
        display: block;
      }
    }
  }

  .el-input__icon {
    margin-right: 8px;
  }
  .content-des {
    height: 300px;
    width: 700px;
    border-color: #dfe1e7;
  }

</style>
<style >
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader .avatar-uploader-icon {
    display: block;
    font-size: 14px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px !important;;
    text-align: center;
  }

  .avatar-uploader .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .video-js {
    width: 700px;
    height: 300px;
    margin-bottom: 6px;
  }
</style>
